import React from "react";

import Image from "../../../../assets/img/static/About.png";
import { Link } from "react-router-dom";

const About = () => {
  return (
    <section className="section bg-secondary" id="about">
      <div className="container mx-auto">
        <div className="flex flex-col xl:flex-row gap-24">
          <img
            className="object-cover h-full w-[566px] md:mx-auto lg:mx-0 rounded-2xl"
            src={Image}
            alt=""
          />
          <div className="flex flex-col items-center text-center lg:items-start lg:text-left">
            <div className="flex flex-col">
              <h2 className="text-3xl lg:text-4xl font-medium lg:font-extrabold mb-3 before:content-about relative before:absolute before:opacity-40 before:-top-[2rem] before:hidden before:lg:block">
                Tech X Neuro
              </h2>
              <p className="mb-4 text-accent">
                {/* graphics design,mobile and web development,branding */}
                Software development, AI & Machine Learning, Devops &
                Automation, Digital Marketing, Media & Creative services
              </p>
              <hr className="mb-8 opacity-5" />
              {/* <p className="mb-8">
                At our company, We specialize in mobile and web development,
                creating dynamic and responsive websites and mobile apps that
                are optimized for performance, user experience, and conversions.
                Our development team is proficient in a range of programming
                languages and technologies, and we can create custom solutions
                that meet your specific requirements. <br />
                <br />
                Our team of experts is proficient in graphic design, mobile app
                development, web development, and branding strategy. We work
                closely with our clients to understand their unique needs and
                develop tailored solutions that meet their objectives.
              </p> */}
              <p className="mb-8">
                We are more than just a technology company-we are innovators,
                problem solvers, and growth enablers. Our mission is to empower
                businesses worldwide by delivering cutting-edge software
                solutions, AI-driven technologies, digital marketing strategies,
                and creative media services. With a passion for innovation and
                excellence, we help startups, enterprises, and global brands
                transform ideas into scalable, high-impact solutions that drive
                success in the digital era.
                <br /> <br />
                With expertise in software development, AI, automation, DevOps,
                and brand building, we deliver tailored, end-to-end solutions.
                Our client-focused approach and industry expertise make us the
                trusted partner for businesses seeking growth, efficiency, and
                impact.
              </p>
            </div>

            <Link
              to="/#contact"
              activeClass="active"
              spy={true}
              smooth={true}
              duration={500}
              offset={-70}
              className="btn btn-md bg-accent hover:bg-secondary-hover transition-all rounded-xl"
            >
              Contact Us
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
};

export default About;
